import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { TokenStore } from '@app/core/auth/token-store';

const apiBaseUrl = environment.api.url.replace(/\/+$/, '');

/**
 * Cross-cutting response handling for API calls: drop the local session on a
 * 401 so the app falls back to the signed-out state. Per-call error shaping is
 * done by `ApiService` (→ `ApiError`); this only covers app-wide concerns.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const tokens = inject(TokenStore);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && req.url.startsWith(apiBaseUrl)) {
        tokens.clear();
      }
      return throwError(() => error);
    }),
  );
};
